module.exports = __webpack_public_path__ + "img/USD.4c62e3ab.png";